import React from 'react';
import {Img} from '@chakra-ui/react';
import {GeoLink} from 'components/action/GeoLink';

export interface MobileLogoProps {
	image?: string;
}

export const MobileLogo: React.FC<MobileLogoProps> = ({
	image
}: MobileLogoProps) => (
	<>
		<GeoLink to='home'>
			<Img
				alt='logo'
				src={image}
				zIndex={1000}
				height='2.5rem'
				width='2.5rem'
			/>
		</GeoLink>
	</>
);
